module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAUCAMAAABVlYYBAAAAP1BMVEUAAAA1NTU4ODg1NTU0NDQ1NTU1NTU4ODg1NTU1NTU1NTU1NTU1NTU0NDQ1NTU1NTU2NjY2NjY0NDQ4ODg1NTWOUQDNAAAAFHRSTlMA3yC/QGBvEDCP78+fr6B/r1BPQNDshiAAAACSSURBVBjTfVBJEsMwCDMY8Bo7afv/t3ZsWi85hAMgDSMB5imc5AQ2vDdS4skeScDiJPMAEv2fDGUOePjRDFp3BKSGpNByy5QUkV2rhJ11sXtJ7xvrVBHbWl3nrGSxYxPdUEA4AFgVFj2ED/fmZdfNcNvMcFKX200lrxeP/5Q0vgN+TlTIl8erzk+qFR8JjkDmKb6sRwM269pueAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/downloadicon2.png
// module id = YWFF
// module chunks = 0